import React from 'react';
import StartTimeSelectTemplate from '../components/template/startTimeSelectTemplate';
import store from '..';
import common from "../resources/js/common/common"
import { golfReservationList } from '../const';
import { GolfHeaderContainer } from '../components/organisms/golfHeaderContainer';
import GolfReservationPopupContainer from '../components/organisms/golfReservationPopupContainer';
import StartTimeSelectContainer from '../components/organisms/startTimeSelectContainer';
class ChangeStartTimeSelect extends React.Component{

    constructor(props) {
        super(props);
        this.state = { 
            popupDataList: [],
            golfReservationPopup : false,
        };
    };

    render(){

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(golfReservationList, { userId : loginId }, afterConfirmGolfReservation);
        }

        // 予約情報取得後処理
        const afterConfirmGolfReservation = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.Data,
                    }
                );
            }
        }

        return(
            <>
            <GolfHeaderContainer 
                    categoryLabel1 ={"スタート時間"} Label 
                    categoryLabel2 = {"TEE TIME"} 
                    path={"/reserve/golf/bookingConfirmDetaile"}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}/>
            <GolfReservationPopupContainer
                    state={this.state}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                />
            <StartTimeSelectContainer 
                reserveType={"change"}
            />
            </>
        )
    }
}
export default ChangeStartTimeSelect;